import { Box, Button, Typography, Select, MenuItem, Card } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import DateTimePicker from "react-datetime-picker";
import React, { FC, useEffect, useState } from 'react';
import { useDataProvider } from 'ra-core';
import { useNotify } from 'react-admin';

import { ReportParams } from '../../types/reports';
import Loader from '../common/loader';
import "./style.css";

let competitions = ["All","Dream home", "Lifestyle Prizes", "Fixed Odds"];

interface Props {
    redirectToReportList: () =>  void
}

const Reports: FC<Props> = ({redirectToReportList}) => {
    const notify = useNotify()
    const dataProvider = useDataProvider()
    const [state, setState] = useState({
        startDate: new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000),
        endDate: new Date(),
        selectedCompetition: competitions[0]
    });
    const [loading, setLoading] = useState(false);
    const [allTypeReport, setAllTypeReport] = useState(false);

    const setStartDate = (value: Date) => {
        setState({ ...state, startDate: value })
    }

    const setEndDate = (value: Date) => {
        setState({ ...state, endDate: value })
    }

    const handleCompetitionChange = (event) => {
        setState({...state, selectedCompetition: event.target.value})
    }

    const createReport = async (isAll: boolean) => {
        const startDate = state.startDate.toISOString()
        const endDate = state.endDate.toISOString()

        if (startDate > endDate) {
            notify('The start date cannot be greater than the finish date.', 'error');
            return
        }

        try {
            setAllTypeReport(isAll)
            setLoading(true);
            const params: ReportParams = {
                competition: state.selectedCompetition,
                isAll: isAll,
                startRange: startDate,
                endRange: endDate
            }
            await dataProvider.createWeeklyReport(params)
            notify(`${isAll ? 'Weekly': '£1,000'} report is being generated. ${isAll ? 'Weekly': '£1,000'} report is accessible to download in the Report list tab`,"info")
            redirectToReportList();
        } catch (err) {
            if (typeof err === "object" && err !== null) {
                const anyErr = err as any;
                if (anyErr.response?.status === 504 || anyErr.status === 504) {
                    notify('This report takes a long time to generate. It will be available in Report list after a while.', 'error', false, false, 15000);
                    return;
                }
                if (anyErr.data?.error) {
                    notify(anyErr.data.error, "error");
                    return;
                }
                if (err instanceof Error && err.message) {
                    notify(err.message, "error");
                }
            }
        } finally {
            setLoading(false);
        }
    }

    return (
            <Card elevation={0} className="reportsCardWrapper" >
                <Box display="flex" alignItems="center" justifyContent="flex-start" >
                    <Box style={{width:250}} paddingBottom="1em">
                        <Typography gutterBottom className="base-color">
                            Start date
                        </Typography>
                    </Box>
                    <form >
                        <Box position="absolute">
                            <DateTimePicker
                                value={state.startDate}
                                format={"dd-MM-y h:mm:ss a"}
                                onChange={setStartDate}
                                disableClock
                                maxDate={new Date("2051-01-18T19:55:00.000+00:00")}
                                minDate={new Date("2000-01-18T19:55:00.000+00:00")}
                            />
                            <Box marginTop="1em" >
                            </Box>
                        </Box>
                    </form>
                </Box>

                <Box display="flex" alignItems="center" justifyContent="flex-start" marginTop="2em">
                    <Box style={{width:250}} paddingBottom="1em">
                        <Typography gutterBottom className="base-color">
                            Finish date
                        </Typography>
                    </Box>
                    <form >
                        <Box position="absolute">

                            <DateTimePicker
                                value={state.endDate}
                                format={"dd-MM-y h:mm:ss a"}
                                onChange={setEndDate}
                                maxDate={new Date("2051-01-18T19:55:00.000+00:00")}
                                minDate={new Date("2000-01-18T19:55:00.000+00:00")}
                                disableClock
                            />
                            <Box marginTop="1em" >
                            </Box>
                        </Box>
                    </form>
                </Box>
                <Box display="flex" alignItems="center" justifyContent="flex-start" marginTop="2em">
                    <Box style={{width:250}}>
                        <Typography className="base-color">
                            Competition type
                        </Typography>
                    </Box>
                    <Select
                        id="search-input"
                        variant="standard"
                        value={state.selectedCompetition}
                        onChange={handleCompetitionChange}
                        name="competition"
                        IconComponent={KeyboardArrowDownIcon}
                    >
                        {competitions.map((name) => (
                            <MenuItem key={name} value={name} >
                                {name}
                            </MenuItem>
                        ))}
                    </Select>
                </Box>
                <Box style={{width:'100%', display: 'flex', gap: '10px'}} marginTop='2rem'>
                    <Button 
                        size="large" 
                        className="getReportsBtn" 
                        onClick={() => createReport(true)}
                        disabled={loading}
                        endIcon={loading && allTypeReport ? <Loader small /> : null}
                    >
                        Create All Tickets Report
                    </Button>
                    <Button 
                        size="large" 
                        className="getReportsBtn" 
                        onClick={() => createReport(false)}
                        disabled={loading}
                        endIcon={loading && !allTypeReport ? <Loader small /> : null}
                    >
                        £1,000 report
                    </Button>
                </Box>
            </Card>
    )
}

export default Reports